import { NgModule } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../_core/core.module';
import { FormsModule } from '@angular/forms';
import { CreditNotesSelectionComponent } from './credit-notes-selection/credit-notes-selection.component';
import { InvoicePayAmtChangeComponent } from './invoice-pay-amt-change/invoice-pay-amt-change.component';
import { AddNeftBalanceComponent } from './add-neft-balance/add-neft-balance.component';
import { InvoiceRejectReasonComponent } from './invoice-reject-reason/invoice-reject-reason.component';
import { InvoiceBankSelectionComponent } from './invoice-bank-selection/invoice-bank-selection.component';
import { NeftStatementComponent } from './neft-statement/neft-statement.component';
import { ChequeDetailComponent } from './cheque-detail/cheque-detail.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { HelpMessageComponent } from './help-message/help-message.component';
import { ClaimsavedComponent } from './claimsaved/claimsaved.component';
import { OutstandingInvDetailsComponent } from './outstanding-inv-details/outstanding-inv-details.component';
import { SalesCollectionForm } from './sales-collection-form/sales-collection-form.component';
import { UserInternetDisconnectedComponent } from './user-internet-disconnected/user-internet-disconnected.component';
import { MessageAlert } from './message-alert/message-alert';
import { SharedModule } from '../_shared/shared.module';
import { InvoicePaySelectVidsComponent } from './invoice-pay-select-vids/invoice-pay-select-vids.component';
import { EnterPinFormComponent } from './enter-pin-form/enter-pin-form.component';
import { InvoicePayDeductionsComponent } from './invoice-pay-deductions/invoice-pay-deductions.component';
import { SwitchLanguageComponent } from './switch-language/switch-language.component';
import { LibModule } from '../_libs/lib.module';
import { SelectAddedCardsPaymetricComponent } from './select-added-cards-paymetric/select-added-cards-paymetric.component';
import { SelectPaymentMethodComponent } from './select-payment-method/select-payment-method.component';
import { XicardFlowDialogComponentComponent } from '../xicard-flow-dialog-component/xicard-flow-dialog-component.component';
import { CreditCardPaymentCVVDialogComponent } from './credit-card-payment-cvv-dialog/credit-card-payment-cvv-dialog.component';
import { CreditCardPaymentStatusDialogComponent } from './credit-card-payment-status-dialog/credit-card-payment-status-dialog.component';

const components = [
  CreditNotesSelectionComponent,
  InvoicePayAmtChangeComponent,
  AddNeftBalanceComponent,
  InvoiceRejectReasonComponent,
  InvoiceBankSelectionComponent,
  NeftStatementComponent,
  ChequeDetailComponent,
  ContactUsComponent,
  HelpMessageComponent,
  SalesCollectionForm,
  OutstandingInvDetailsComponent,
  ClaimsavedComponent,
  ContactUsComponent,
  UserInternetDisconnectedComponent,
  MessageAlert,
  InvoicePaySelectVidsComponent,
  EnterPinFormComponent,
  InvoicePayDeductionsComponent,
  SwitchLanguageComponent,
  SelectAddedCardsPaymetricComponent,
  SelectPaymentMethodComponent,
  CreditCardPaymentCVVDialogComponent,
  XicardFlowDialogComponentComponent,
  CreditCardPaymentStatusDialogComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CoreModule,
    SharedModule,
    LibModule
  ],
  declarations: components,
  exports: components,
  entryComponents: components
})
export class AppModalsModule { };
